export const USER_STORAGE_KEY = "edu-student-application";
export const PAYMENT_CHANNEL_KEY = "edu-app-payment-channel";
export const INSTITUTION_NAME = process.env.REACT_APP_INSTITUTION_NAME;

export const INTERSWITCH_PAYMENT_URL =
  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
    ? process.env.REACT_APP_INTERSWITCH_STAGING_URL || ""
    : process.env.REACT_APP_INTERSWITCH_PROD_URL || "";

export const APP_API_URL = process.env.REACT_APP_PROD_API_URL || "";

// Fallback public key for the Remita inline widget, used only if the backend
// does not return one in the payment initialization response.
export const REMITA_PUBLIC_KEY = process.env.REACT_APP_REMITA_PUBLIC_KEY || "";

export const APP_BASE_URL = process.env.REACT_APP_PROD_BASE_URL || "";

// export const APP_API_URL =
//   process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
//     ? process.env.REACT_APP_STAGING_API_URL || ""
//     : process.env.REACT_APP_PROD_API_URL || "";

// export const APP_BASE_URL =
//   process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
//     ? process.env.REACT_APP_STAGING_BASE_URL || ""
//     : process.env.REACT_APP_PROD_BASE_URL || "";

export const applicantTypeMap = {
  Regular: 1,
  Indigene: 2,
  International: 3,
};
